<template>
  <svg
    class="brand-logo"
    :viewBox="viewBox"
    aria-hidden="true"
    focusable="false"
  >
    <defs v-if="mode === 'reveal'">
      <mask
        v-for="wave in waves"
        :key="wave.key"
        :id="maskId(wave.key)"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        :width="width"
        :height="height"
      >
        <rect
          :class="['logo-reveal', `logo-reveal--${wave.key}`]"
          x="0"
          y="-6"
          width="286"
          height="152"
          fill="#fff"
        />
      </mask>
    </defs>

    <!-- path selalu dibungkus g, karena denyut loading nabrak transform path -->
    <g v-for="wave in waves" :key="wave.key" :class="groupClass(wave.key)">
      <path
        :d="wave.d"
        :transform="transform"
        :fill="wave.color"
        :mask="maskRef(wave.key)"
      />
    </g>
  </svg>
</template>

<script>
import {
  LOGO_WAVES, LOGO_VIEW_BOX, LOGO_TRANSFORM, LOGO_WIDTH, LOGO_HEIGHT,
} from '@/util/auth/brandLogoPaths';

// tiap logo dapat nomornya sendiri biar id mask gak kembar antar instance
let instanceSeq = 0;

export default {
  name: 'AuthBrandLogo',
  props: {
    mode: {
      type: String,
      default: 'plain',
      validator: (value) => ['plain', 'pulse', 'reveal'].includes(value),
    },
  },
  data() {
    instanceSeq += 1;
    return { uid: instanceSeq };
  },
  computed: {
    waves() { return LOGO_WAVES; },
    viewBox() { return LOGO_VIEW_BOX; },
    transform() { return LOGO_TRANSFORM; },
    width() { return LOGO_WIDTH; },
    height() { return LOGO_HEIGHT; },
  },
  methods: {
    maskId(key) { return `mtz-reveal-${key}-${this.uid}`; },
    maskRef(key) { return this.mode === 'reveal' ? `url(#${this.maskId(key)})` : null; },
    groupClass(key) {
      return this.mode === 'pulse' ? ['loading-wave', `loading-wave--${key}`] : null;
    },
  },
};
</script>
